module.exports = __webpack_public_path__ + "0f8f379b3dfaa773b9853e76cd2e56e3.svg";